import ApiService from './apiService';
import {
  CreditSummary,
  FeesSummary,
  VoxSummary,
  DashboardDetailRequest,
  ApiTransactionDetail,
  VoxOrderDetail,
  PagedResult,
} from '../models/reporting/reporting';

class ReportingService extends ApiService {
  private static instance?: ReportingService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!ReportingService.instance) {
      ReportingService.instance = new ReportingService();
    }
    return ReportingService.instance;
  }

  private buildDateParams(startDate: Date, endDate: Date) {
    return { startDate: startDate.toISOString(), endDate: endDate.toISOString() };
  }

  getCreditSummary(startDate: Date, endDate: Date): Promise<CreditSummary> {
    return this.client
      .get('reporting/credit/summary', { params: this.buildDateParams(startDate, endDate) })
      .then((response) => response.data);
  }

  getFeesSummary(startDate: Date, endDate: Date): Promise<FeesSummary> {
    return this.client
      .get('reporting/fees/summary', { params: this.buildDateParams(startDate, endDate) })
      .then((response) => response.data);
  }

  getVoxSummary(startDate: Date, endDate: Date): Promise<VoxSummary> {
    return this.client
      .get('reporting/vox/summary', { params: this.buildDateParams(startDate, endDate) })
      .then((response) => response.data);
  }

  getCreditDetails(request: DashboardDetailRequest): Promise<PagedResult<ApiTransactionDetail>> {
    return this.client.post('reporting/credit/details', request).then((response) => response.data);
  }

  getFeesDetails(request: DashboardDetailRequest): Promise<PagedResult<ApiTransactionDetail>> {
    return this.client.post('reporting/fees/details', request).then((response) => response.data);
  }

  getVoxDetails(request: DashboardDetailRequest): Promise<PagedResult<VoxOrderDetail>> {
    return this.client.post('reporting/vox/details', request).then((response) => response.data);
  }
}

export default ReportingService;
